<template>
  <sp-fieldset>
    <sp-switch
      :checked="model.fullBleed"
      label="Full Bleed"
      help-text="Ignore container width and span full viewport"
      @update-checked="updateFullBleed"
    ></sp-switch>
  </sp-fieldset>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
});

const model = computed(() => props.modelValue);

function updateFullBleed({ detail }) {
  const [checked] = detail;
  model.value.fullBleed = checked;
}
</script>
